<template>
  <div class="profile-fields py-10 w-1/2">
    <ValidationObserver tag="div" ref="observer">
      <FormRow
        label="Email"
        for-id="profile-email"
        name="Email"
        rules="required|email"
      >
        <v-input
          type="text"
          v-model="modelData.email"
          id="profile-email"
          name="profile-email"
          :disabled="updateLoading"
        />
      </FormRow>
      <FormRow label="Nome" for-id="profile-name" name="Nome" rules="required">
        <v-input
          type="text"
          v-model="modelData.displayName"
          id="profile-name"
          name="profile-name"
          :disabled="updateLoading"
        />
      </FormRow>
      <FormRow
        label="Password"
        :legend="passwordLegend"
        for-id="profile-password"
        name="Password"
        :rules="passwordRules"
      >
        <v-input
          type="password"
          v-model="modelData.password"
          id="profile-password"
          name="profile-password"
          :disabled="updateLoading"
        />
      </FormRow>
      <FormRow
        label="Conferma Password"
        for-id="profile-password-confirmation"
        name="Conferma Password"
        rules="confirm:@profile-password"
        ref="confirmPassword"
      >
        <v-input
          type="password"
          v-model="confirmPassword"
          id="profile-password-confirmation"
          name="profile-password-confirmation"
          :disabled="updateLoading"
        />
      </FormRow>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    ValidationObserver,
  },

  props: {
    displayName: {
      type: String,
      default: '',
    },

    email: {
      type: String,
      default: '',
    },

    isAdmin: {
      type: Boolean,
      default: false,
    },

    password: {
      type: String,
      default: '',
    },

    updateLoading: {
      type: Boolean,
      default: false,
    },

    requirePassword: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modelData: {
        displayName: this.displayName,
        email: this.email,
        password: '',
      },
      initialData: {
        displayName: this.displayName,
        email: this.email,
        password: '',
      },
      confirmPassword: '',
    }
  },

  computed: {
    passwordLegend() {
      if (this.requirePassword) {
        return '(Minimo 8 caratteri)'
      }

      return '(Minimo 8 caratteri, lasciare vuoto per mantenere quella attuale)'
    },
    passwordRules() {
      const rules = ['min:8']

      if (this.requirePassword) {
        rules.unshift('required')
      }

      return rules.join('|')
    },
  },

  watch: {
    modelData: {
      deep: true,
      handler() {
        const dirty = Object.keys(this.modelData).reduce((isDirty, key) => {
          return isDirty || this.modelData[key] !== this.initialData[key]
        }, false)

        this.$emit('update', {
          dirty,
          modelData: this.modelData,
        })

        this.$refs.confirmPassword.$refs.provider.validate()
      },
    },
  },

  methods: {
    resetPasswordFields() {
      this.modelData.password = ''
      this.initialData.password = ''
      this.confirmPassword = ''
    },
  },

  mounted() {
    this.unwatchValidation = this.$watch(
      '$refs.observer.flags.valid',
      valid => {
        this.$emit('valid', valid)
      },
      {
        immediate: true,
      },
    )
  },
}
</script>
